module.exports = __webpack_public_path__ + "img/badge_color_hs-career.1d91437d.svg";